import type { ReactNode } from "react";

import { cx } from "./cx";
import { activateOnKey } from "./keyActivate";
import styles from "./StatTile.module.css";

export type StatTone = "neutral" | "money" | "accent";

export interface StatTileProps {
  label: ReactNode;
  value: ReactNode;
  icon?: ReactNode;
  tone?: StatTone;
  flash?: boolean;
  onClick?: () => void;
  className?: string;
}

export function StatTile({
  label,
  value,
  icon,
  tone = "neutral",
  flash = false,
  onClick,
  className,
}: StatTileProps): JSX.Element {
  const interactive = onClick !== undefined;
  return (
    <div
      className={cx(styles.tile, flash && styles.flash, interactive && styles.clickable, className)}
      onClick={onClick}
      onKeyDown={onClick ? activateOnKey(onClick) : undefined}
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
    >
      <div className={styles.top}>
        {icon && (
          <span className={styles.icon} aria-hidden="true">
            {icon}
          </span>
        )}
        {label}
      </div>
      <div className={cx(styles.value, styles[tone])}>{value}</div>
    </div>
  );
}
